import React from 'react';
import { TaskPriority as TaskPriorityType } from '../types/todo';
import { Flag } from 'lucide-react';

interface TaskPriorityProps {
  priority?: TaskPriorityType;
  isPreview: boolean;
  onClick: () => void;
}

export function TaskPriority({ priority = 'low', isPreview, onClick }: TaskPriorityProps) {
  const getPriorityConfig = (p: TaskPriorityType) => {
    switch (p) {
      case 'high':
        return { label: 'Haute', classes: 'bg-red-50 dark:bg-red-900/20 text-red-600 dark:text-red-400 border-red-100 dark:border-red-800/30' };
      case 'medium':
        return { label: 'Moyenne', classes: 'bg-amber-50 dark:bg-amber-900/20 text-amber-600 dark:text-amber-400 border-amber-100 dark:border-amber-800/30' };
      case 'low':
        return { label: 'Basse', classes: 'bg-emerald-50 dark:bg-emerald-900/20 text-emerald-600 dark:text-emerald-400 border-emerald-100 dark:border-emerald-800/30' };
    }
  };

  const config = getPriorityConfig(priority);

  if (isPreview) {
    return (
      <span className={`inline-flex items-center gap-1 px-2.5 py-1 sm:px-2 sm:py-0.5 rounded-lg sm:rounded-md text-xs sm:text-[10px] font-medium border ${config.classes}`}>
        <Flag className="w-3.5 h-3.5 sm:w-3 sm:h-3" />
        {config.label}
      </span>
    );
  }

  return (
    <button
      onClick={onClick}
      className={`inline-flex items-center gap-1.5 sm:gap-1 px-2.5 py-1.5 sm:px-2 sm:py-0.5 rounded-lg sm:rounded-md text-xs sm:text-[10px] font-medium border transition-all duration-150 hover:opacity-80 active:scale-95 ${config.classes}`}
    >
      <Flag className="w-3.5 h-3.5 sm:w-3 sm:h-3" />
      {config.label}
    </button>
  );
}
